// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__Nibv4","div1":"Contact_div1__SKPp-","div2":"Contact_div2__qwCUf","div2left":"Contact_div2left__C62+p","div2right":"Contact_div2right__F-lSV"};